/**
 * chat-entry.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

export class ChatEntry {
  public action : string;
  constructor (
    public message : string,
    public author : string,
    public group : string = ""
  )
  {
    // Nothing
  }

  public static join (author : string, group : string) : ChatEntry
  {
    return Object.assign(
      new ChatEntry(null, author, group),
      {action: "joined"}
    );
  }

  public static leave (author : string, group : string) : ChatEntry
  {
    return Object.assign(
      new ChatEntry(null, author, group),
      {action: "left"}
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/intake-form/chat-entry.ts